type UmamiTracker = {
  track: (eventName: string, eventData?: Record<string, unknown>) => void
}

declare global {
  interface Window {
    umami?: UmamiTracker
  }
}

export const ANALYTICS_EVENTS = {
  StatisticsReportGenerate: 'statistics-report-generate'
} as const

export type AnalyticsEventName =
  (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS]

export function trackEvent(
  eventName: AnalyticsEventName,
  eventData?: Record<string, unknown>
): void {
  try {
    if (typeof window === 'undefined' || !window.umami) return
    window.umami.track(eventName, eventData)
  } catch {
    // Analytics must never break the app
  }
}
